import { MapUnit } from "./MapUnit";

export class MapDataCountry {
  constructor(public code: string, public name: string, public value?: number) {

  }
  unit?: MapUnit;
  source?: string;

  get displayValue() {
    if (this.value === null || this.value === undefined) {
      return this.value;
    }

    let formatter = Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });
    if (!Number.isInteger(this.value) && Math.abs(this.value) < 1) {
      formatter = Intl.NumberFormat("en-US", { maximumSignificantDigits: 1 });
    }
    return formatter.format(this.value);
  }

  get roundedValue() {
    return Number(this.displayValue?.replaceAll(' ', '').replaceAll(',', ''));
  }
}

window['MapDataCountry'] = MapDataCountry;